import {useApiCall} from "../../../../api";
import {FC} from "react";
import {DocPageVersion} from "../DocumentPageHeader";
import {ModalFooter, useModalControls} from "../../../layout/ModalProvider";
import {ConfigInterface} from "../../../../config";

export const RevertVersionModal: FC<{ config: ConfigInterface, version: DocPageVersion, onPageReverted: (version: DocPageVersion) => void}> = (props) => {
  const { documentations } = useApiCall(props.config)
  const {closeAll} = useModalControls()

  const confirm = async () => {
    await documentations.revertPageVersion(props.version.teamSpacePageId, props.version.id)
    props.onPageReverted(props.version)
    closeAll()
  }

  return <div>
    <div>Weet je zeker dat je versie <span className={'bold'}>{props.version.version}</span> actief wilt zetten?</div>
    <ModalFooter text={"Terugzetten"} onSubmit={confirm} />
  </div>
}